import React, { useState,useRef } from "react";
import "../assets/css/ConfirmJoinModal.css"; // Create this CSS file

import   Success from "../assets/img/check-mark.svg"; // Create this CSS file

import   Failure from "../assets/img/failure.svg"; // Create this CSS file
import   Loading from "../assets/img/spinner-of-dots.svg"; // Create this CSS file


export default function ConfirmJoinModal({ open, onClose, onConfirm, sponsor, status }) {
  const [termsChecked, setTermsChecked] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [termsModalVisible, setTermsModalVisible] = useState(false);
  
    const [canCloseTerms, setCanCloseTerms] = useState(false);
  const termsScrollRef = useRef(null);

  if (!open && (!status || !status.visible)) return null;

  const handleConfirm = () => {
    if (!termsChecked) {
      setModalMessage("Please accept the Terms & Conditions first!");
      setModalVisible(true);
      setTimeout(() => setModalVisible(false), 2000);
      return;
    }

    onConfirm({ acceptedTerms: termsChecked });
  };

    const handleTermsScroll = () => {
    const el = termsScrollRef.current;
    if (!el) return;

    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 2) {
      setCanCloseTerms(true);
    }
  };

  return (
    <div className="cjm-backdrop">
      <div className="cjm-modal">


            <span className="top-line spn-bg"></span>
                  <span className="right-line spn-bg"></span>
                  <span className="bottom-line spn-bg"></span>
                  <span className="left-line spn-bg"></span>
        <button onClick={onClose} className="cjm-close">
          ✕
        </button>

        {/* Status Modal */}
        {status && status.type !== "ready" ? (
          <div className="cjm-status-container">
            {status.type === "loading" && <div className="cjm-status-icon spin"><img src={Loading} className="Failure-img" /></div>}
            {status.type === "success" && <div className="cjm-status-icon success"> <img src={Success} className="Failure-img" /></div>}
            {status.type === "error" && <div className="cjm-status-icon error">
              
              <img src={Failure} className="Failure-img" />
              
              </div>}

            <h3 className="cjm-status-title">{status.title}</h3>
            <p className="cjm-status-message">{status.message}</p>

            {status.type !== "loading" && (
              <button onClick={onClose} className="cjm-status-btn">
                OK
              </button>
            )}
          </div>
        ) : (
          <>
            <h3 className="cjm-title">Confirm Joining</h3>
            <p className="cjm-subtitle">Please verify your sponsor address before joining.</p>

            <div className="cjm-sponsor">{sponsor}</div>

            <div className="cjm-terms">
              <input
                type="checkbox"
                checked={termsChecked}
                onChange={() => setTermsChecked(!termsChecked)}
              />
              <label>
                I accept the{" "}
                <span className="cjm-terms-link" onClick={() => setTermsModalVisible(true)}>
                  Terms & Conditions
                </span>
              </label>
            </div>

            <button onClick={handleConfirm} className="cjm-confirm-btn">
              Confirm & Join
            </button>
          </>
        )}
      </div>

      {modalVisible && (
        <div className="cjm-warning-backdrop">
          <div className="cjm-warning-modal">{modalMessage}</div>
        </div>
      )}

      {/* {termsModalVisible && (
        <div className="cjm-terms-backdrop">
          <div className="cjm-terms-modal">
            <button onClick={() => setTermsModalVisible(false)} className="cjm-close">
              ✕
            </button>
            <h2 className="cjm-terms-title">Terms & Conditions</h2>
            <div className="cjm-terms-content"> */}

              {termsModalVisible && (
        <div className="cjm-terms-backdrop">
          <div className="cjm-terms-modal">

            {/* 🔒 HEADER – NEVER SCROLLS */}
            <div className="cjm-terms-header">
              <h2>Terms & Conditions for iBullz</h2>
              <button
                className={`cjm-close ${!canCloseTerms ? "disabled" : ""}`}
                onClick={() => canCloseTerms && setTermsModalVisible(false)}
              >
                ✕
              </button>
            </div>

            {/* 🔥 ONLY THIS SCROLLS */}
            <div
              className="cjm-terms-body"
              ref={termsScrollRef}
              onScroll={handleTermsScroll}
            >
              

              <div className="terms-wrapper">
      <div className="terms-container">

        <h5>Acceptance of Terms</h5>
        <p>
          Welcome to <b>iBullz</b>. By accessing, registering for, or using our
          services, you agree to these Terms & Conditions. If you do not agree,
          you must not use the Platform.
        </p>

        <h5>Eligibility</h5>
         <p>
          To use our Platform, you must:
        </p>
        <ul>
          <li>Be at least 18 years old (or the age of majority in your jurisdiction).</li>
          <li>Have the legal capacity to enter into a binding contract.</li>
          <li>Not be a resident of a jurisdiction where cryptocurrency trading is prohibited or where our services are restricted (see Section 13).</li>
          <li>Not be on any trade or economic sanctions lists </li>
        </ul>

        <h5>Description of Services</h5>
         <p>
          Our Platform provides:
        </p>
        <ul>
          <li>A marketplace to buy, sell, and trade certain digital assets ("Cryptocurrencies").</li>
          <li>Digital wallet services for storing cryptographic keys.</li>
          <li>Market information and trading tools.</li>
        </ul>
        <p className="note">
          We are not: a financial advisor, broker-dealer, or investment manager. We do not provide financial, legal, or tax advice. You are solely responsible for your trading decisions.
        </p>

        <h5>User Registration & Security</h5>
        <ul>
          <li>Account Creation: You must provide accurate and complete information. You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.</li>
          <li>No Account Sharing: You may not share, transfer, or allow others to use your account.</li>
        </ul>

        <h5>Risks of Cryptocurrency Trading</h5>
        <p>
         You acknowledge and accept the following inherent risks, which are not exhaustive:
        </p>
        <ul>
          <li>Market Volatility: Cryptocurrency prices can fluctuate extremely rapidly. You may lose all of your invested capital.</li>
          <li>Regulatory Uncertainty: Laws and regulations are evolving and vary by jurisdiction, which may affect the use, transfer, or value of your assets.</li>
          <li>Technological Risks: This includes hacking, phishing, malware, flaws in smart contracts, and the failure of blockchain networks.</li>
          <li>Irreversible Transactions: Cryptocurrency transactions are typically final and cannot be reversed once confirmed on the blockchain.</li>
          <li>Loss of Private Keys: Loss of your wallet's private keys means permanent, irrecoverable loss of your assets.</li>
          <li>No FSCS/FDIC Protection: Cryptocurrencies held on the Platform are not protected by government-backed deposit insurance schemes.</li>
        </ul>

        <h5>Trading Rules & Fees</h5>
        <ul>
          <li>Orders: You may place buy/sell orders, which are matched according to our platform's order book. We do not guarantee the execution of any order.</li>
          <li>Fees: All applicable fees (trading, withdrawal, network/gas fees) will be clearly displayed before you confirm a transaction. Fees are subject to change with notice.</li>
          <li>Market Conduct: You agree not to engage in market manipulation, spoofing, wash trading, or any other abusive trading practices.</li>
        </ul>

        <h5>Deposits, Withdrawals & Custody</h5>
        <ul>
          <li>Deposits: You may deposit supported cryptocurrencies into your Platform wallet. Deposits require a minimum number of blockchain confirmations.</li>
          <li>Withdrawals: Withdrawals are subject to security reviews, limits, and fees. You are solely responsible for providing the correct withdrawal address.</li>
          <li>Custody: We hold a majority of user assets in secure, offline cold storage. A smaller portion is kept in hot wallets for liquidity.</li>
        </ul>

        <h5>Prohibited Activities</h5>
         <p>
         You agree NOT to use the Platform to:
        </p>
        <ul>
          <li>Violate any law or regulation.</li>
          <li>Engage in fraud or money laundering.</li>
          <li>Trade with proceeds of illegal activity.</li>
          <li>Infringe on intellectual property rights.</li>
          <li>Interfere with the security or operation of the Platform.</li>
          <li>Provide false information.</li>
        </ul>

        <h5>Termination & Suspension</h5>
        <p>
          We reserve the right to, at our sole discretion:
        </p>
         <ul>
          <li>Suspend or terminate your account.</li>
          <li>Halt trading or withdrawals.</li>
          <li>Refuse any transaction.If we suspect illegal activity, a security breach, or a violation of these Terms. We will provide notice where legally required and feasible.</li>
        </ul>

        <h5>Intellectual Property</h5>
        <p>
          All Platform software, design, logos, and content are our exclusive property or licensed to us. You are granted a limited license to use the Platform for its intended purposes only.
        </p>

        <h5>Limitation of Liability & Disclaimer of Warranties</h5>
        <ul>
          <li>"As Is" Service: The Platform is provided on an "AS IS" and "AS AVAILABLE" basis, without warranties of any kind.</li>
          <li>Limitation of Liability: To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including lost profits or data, arising from your use of the Platform, even if we have been advised of the possibility of such damages.</li>
          <li>Force Majeure: We are not liable for delays or failures in performance due to events beyond our reasonable control (e.g., acts of God, war, blockchain forks, internet outages).</li>
        </ul>

        <h5>Indemnification</h5>
        <p>
         You agree to indemnify and hold harmless iBullz, its affiliates, and their directors, employees, and agents from any claims, damages, losses, or costs (including legal fees) arising from your breach of these Terms or your misuse of the Platform.
        </p>

        <h5>Governing Law & Disputes</h5>
        <p>
          These Terms shall be governed by the laws of United Arab Emirates, Dubai. Any dispute shall be resolved through final and binding arbitration in Dubai, except that either party may seek injunctive relief in court to prevent irreparable harm.
        </p>

        <h5>Changes to Terms</h5>
        <p>
          We may amend these Terms at any time. We will notify you of material changes via email or an in-platform announcement. Your continued use of the Platform after the effective date of the revised Terms constitutes your acceptance of them.
        </p>

      </div>
    </div>


    
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
